import React from 'react';
import { ListChecksIcon, LayoutGridIcon, FileSearchIcon, WorkflowIcon } from 'lucide-react';
import { WHY_POINTS } from '../../data/homeContent';
import { PRODUCT_SCREENSHOTS } from '../../data/dgpt';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { StepImage } from '../dgpt/product/StepImage';
const ICONS = [ListChecksIcon, LayoutGridIcon, FileSearchIcon, WorkflowIcon];
export function WhySection() {
  return <section aria-labelledby="why-heading" className="border-b border-hairline-soft bg-ink" data-id="element-235" data-mp="12pe6g6wtal0y">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-24" data-id="element-236" data-mp="17nz6o6c2d4pe">
        <SectionHeading eyebrow="Why DiligenceGPT™" headingId="why-heading" title="Bring structure to your investment analysis." data-id="element-237" data-mp="1cnbrkljdk1pc" />
        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-238" data-mp="k10rrd3le4tl">
          {WHY_POINTS.map((point, index) => {
          const Icon = ICONS[index];
          return <Reveal key={point.title} as="li" delay={index * 0.05} className="rounded-2xl border border-hairline bg-panel p-6" data-id="element-239" data-mp="oxhhucucqt9b" data-mpi={index}>
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#F1EFFA] text-lime" data-id="element-240" data-mp="2iu9xbukxiskb">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-241" data-mp="2e306iqnn9j6u" />
                </span>
                <h3 className="mt-5 text-base font-semibold tracking-[-0.015em] text-text-primary" data-id="element-242" data-mp="2a39k0z55hp84">{point.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-text-secondary" data-id="element-243" data-mp="254eu7d8rn0ei">{point.body}</p>
              </Reveal>;
        })}
        </ul>
        <Reveal delay={0.1} className="mt-10" data-id="element-244" data-mp="1v57ggoy4d3qv">
          <StepImage image={PRODUCT_SCREENSHOTS.pipeline} data-id="element-245" data-mp="1v5yysy2ph4z7" />
          <p className="mt-3 text-xs text-text-tertiary" data-id="element-246" data-mp="1r3vnc9g1e0dx">Pipeline view: every deal assessed against the same thesis criteria.</p>
        </Reveal>
      </div>
    </section>;
}